import React from "react"
import { StoreProvider } from "./src/context/StoreContext"

const WrapWithProvider = ({ element }) => (
  <StoreProvider>{element}</StoreProvider>
)

export default WrapWithProvider;